<template>
  <div class="bot-section">
    <div class="bot-section__toolbar" v-if="merge.length > 1">
      <button
        :disabled="!main"
        class="btn btn-sm bot-section__button bot-section__button--warning"
        v-on:click="fetch"
      >
        Об'єднати резерви
      </button>
    </div>

    <div class="bot-section__table-card">
      <table class="table table-hover bot-section__table">
        <thead>
          <tr>
            <th></th>
            <th
              class="text-center"
              v-for="header of headers"
              v-bind:key="header.field"
            >
              {{ header.name }}
            </th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody
          v-for="(row, index) of rows"
          v-bind:key="index"
        >
          <tr>
            <td
              v-on:click.prevent="getProducts(row.id)"
              v-if="products.filter(x => x?.activityId == row.id).length == 0"
            >+</td>
            <td
              v-on:click.prevent="removeProducts(row.id)"
              v-else
            >-</td>
            <td
              class="text-center"
              v-bind:class="header.class ? header.class : ''"
              v-for="header of headers"
              v-bind:key="index + header.field"
              v-on:click="router(row.id, 'OrderBotPage')"
            >
              {{ getRowValue(row, header) }}
            </td>
            <td>
              <button
                class="btn btn-sm bot-section__button bot-section__button--danger"
                v-on:click.prevent="cancel(row.number, row.contact.code)"
              >
                {{ $filters.localize("button.cancel") }}
              </button>
            </td>
            <td>
              <button
                v-if="merge.filter(x => x == row.id).length == 0"
                class="btn btn-sm bot-section__button bot-section__button--info"
                v-on:click.prevent="addMerge(row.id)"
              >Об'єднати</button>
              <button
                v-else
                class="btn btn-sm bot-section__button bot-section__button--warning"
                v-on:click.prevent="removeMerge(row.id)"
              >Не об'єднувати</button>
              <button
                v-if="merge.filter(x => x == row.id).length == 1 && main == row.id"
                class="btn btn-sm bot-section__button bot-section__button--success"
                v-on:click="resetMain(row.id)"
              >Основний</button>
              <button
                v-if="merge.filter(x => x == row.id).length == 1 && main != row.id"
                class="btn btn-sm bot-section__button bot-section__button--warning"
                v-on:click="resetMain(row.id)"
              >Скасувати</button>
            </td>
          </tr>
          <tr v-if="products.filter(x => x?.activityId == row.id).length > 0">
            <td :colspan="headers.length + 3">
              <table class="table table-sm bot-section__nested-table">
                <thead>
                  <tr>
                    <th class="text-center">{{ $filters.localize("tableColumns.common.products_Product_Code_Custom") }}</th>
                    <th class="text-center">{{ $filters.localize("main.size") }}</th>
                  </tr>
                </thead>
                <tbody
                  v-for="productRow of products.filter(x => x?.activityId == row.id)"
                  v-bind:key="productRow.id"
                >
                  <tr>
                    <td>{{ productRow.product?.code }}</td>
                    <td>{{ productRow.productRemain?.character?.name }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="rows.length === 0"
        class="bot-section__empty"
      >
        У вас відсутні активні резерви
      </div>
    </div>
  </div>
</template>

<script>
import rows from "@/mixins/rows.js";

export default {
  name: "Reservations",
  mixins: [rows],
  data() {
    return {
      headers: [
        { field: "number", name: this.$filters.localize("tableColumns.common.number") },
        { field: "reservationExpired", name: this.$filters.localize("tableColumns.reservation.reservationExpired"), isDate: true },
      ],
      rows: [],
      products: [],
      merge: [],
      main: null,
    };
  },
  methods: {
    loadRows() {
      this.$http
        .get(window.location.origin + "/api/v1/order/reservations")
        .then((response) => {
          this.rows = response.data.data;
          this.rows.forEach((row) => this.getProducts(row.id));
        });
    },
    getProducts(rootId) {
      this.$store
        .dispatch("getFilter", {
          table: "orderproduct",
          body: { id: rootId, rootColumn: "ActivityId" },
        })
        .then((response) => {
          this.products = [...this.products, ...response.data.data];
        });
    },
    removeProducts(rootId) {
      this.products = this.products.filter((x) => x?.activityId !== rootId);
    },
    cancel(number, contact) {
      this.$store
        .dispatch("postAPI", {
          controller: "order",
          method: "cancel/byNumber",
          body: { number, contact },
        })
        .then(() => {
          this.$toast.success("Резерв знято");
          this.loadRows();
        })
        .catch((error) => {
          this.$toast.error(error.response.data.message);
        });
    },
    addMerge(id) {
      this.merge.push(id);
      if (!this.main) {
        this.resetMain(id);
      }
    },
    removeMerge(id) {
      this.merge = this.merge.filter((x) => x !== id);

      if (this.main == id && this.merge.length > 0) {
        this.main = this.merge[0];
      }
    },
    resetMain(id) {
      if (this.main == id) {
        if (this.merge.length > 0) {
          this.main = this.merge[0];
        } else this.main = null;
      } else {
        this.main = id;
      }
    },
    fetch() {
      var main = this.rows.find((x) => x.id == this.main);
      this.$store
        .dispatch("postAPI", {
          controller: "order",
          method: "merge",
          body: {
            main: this.main,
            orders: this.merge.filter((x) => x != this.main),
          },
        })
        .then(() => {
          this.$toast.success("Резерви об'єднані до основного резерву №" + main.number);
          this.$toast.info("Решта обраних резервів скасовані.");
          this.loadRows();
          this.main = null;
          this.merge = [];
        })
        .catch(() => {
          this.$toast.error("Резерви не можуть бути об'єднані між собою");
        });
    },
  },
  mounted() {
    this.loadRows();
  },
};
</script>

<style scoped>
.bot-section {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bot-section__toolbar {
  flex: 0 0 auto;
  display: flex;
  gap: 8px;
  padding: 10px;
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(15, 38, 65, 0.05);
}

.bot-section__table-card {
  position: relative;
  min-height: 0;
  flex: 1;
  overflow: auto;
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 14px 30px rgba(15, 38, 65, 0.08);
  -webkit-overflow-scrolling: touch;
}

.bot-section__table {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
  margin-bottom: 0;
}

.bot-section__table th {
  position: sticky;
  top: 0;
  z-index: 2;
  border-bottom: 1px solid #dfe7f0;
  color: #526171;
  background: #f7fafc;
  font-size: 0.76rem;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
}

.bot-section__table td {
  vertical-align: middle;
  overflow-wrap: anywhere;
}

.bot-section__table th:first-child,
.bot-section__table td:first-child {
  width: 34px;
}

.bot-section__table th:nth-last-child(-n + 2),
.bot-section__table td:nth-last-child(-n + 2) {
  width: 104px;
}

.bot-section__nested-table {
  margin-bottom: 0;
  background: #f7fafc;
}

.bot-section__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  margin: 2px;
  border-radius: 8px;
  font-size: 0.72rem;
  font-weight: 800;
  white-space: nowrap;
}

.bot-section__button--danger {
  color: #b42318;
  border-color: #f0a8a0;
  background: #fff8f7;
}

.bot-section__button--info {
  color: #2563eb;
  border-color: #8bb8ff;
  background: #f7fbff;
}

.bot-section__button--warning {
  color: #8a4b00;
  border-color: #f4c46b;
  background: #fff8e6;
}

.bot-section__button--success {
  color: #0f7a3a;
  border-color: #86d99a;
  background: #f0fdf4;
}

.bot-section__empty {
  position: absolute;
  inset: 42px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: #7b8794;
  text-align: center;
  font-weight: 700;
}

@media (max-width: 767.98px) {
  .bot-section {
    gap: 8px;
  }

  .bot-section__toolbar {
    padding: 8px;
  }

  .bot-section__table {
    font-size: 0.72rem;
  }

  .bot-section__table th,
  .bot-section__table td {
    padding: 5px 4px;
  }

  .bot-section__table th:first-child,
  .bot-section__table td:first-child {
    width: 28px;
  }

  .bot-section__table th:nth-last-child(-n + 2),
  .bot-section__table td:nth-last-child(-n + 2) {
    width: 76px;
  }

  .bot-section__button {
    min-height: 28px;
    padding: 3px 5px;
    font-size: 0.66rem;
  }
}
</style>
